import { render, staticRenderFns } from "./alterLicense.vue?vue&type=template&id=03dcc72c&"
import script from "./alterLicense.vue?vue&type=script&lang=js&"
export * from "./alterLicense.vue?vue&type=script&lang=js&"
import style0 from "./alterLicense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports